import InputText from './InputText';
import './InputText.scss';

export default InputText;
